/* eslint-disable */
//  Interceptor Tutorial
// https://www.bezkoder.com/axios-interceptors-refresh-token/
import { getConfig } from "@config/index";
import { AxiosInstance, AxiosResponse } from "axios";
// import { ENDPOINTS } from '@repositories/AuthRepository';
import {
  AUTH_TOKEN_EXPIRED_MESSAGE,
  ERR_UNSUPPORTED_VERSION,
  HTTP_STATUS_CODES,
  UNDER_MAINTENANCE,
} from "./constants";
import { IApiClient } from "@network/interfaces";
import { logoutAction } from "@common/redux/auth/actions";
import UserService from "@erelego/design-system/components/atoms/login/keycloak";
import { getRedirectUri } from "@common/redux/auth/utils";
import { getStore } from "@common/utils/storeInjection";

export const addAuthorizationRequestInterceptor = (
  axiosInstance: AxiosInstance,
  apiClient: IApiClient
): AxiosInstance => {
  axiosInstance.interceptors.request.use(
    async (config) => {
      const authHelper = apiClient?.getAuthHelper();
      const clientToken = await authHelper?.getAccessToken();

      Object.assign(config.headers, {
        ...(config.data instanceof FormData ? {} : { "Content-Type": "application/json" }),
        "Access-Control-Allow-Origin": "*",
        "access-control-expose-headers": "true",
        "access-control-allow-headers": "true",
      });
      const value = getConfig()?.ALLOWED_BASE_URLS || [".munshify.com"];
      let allowedBase;
      if (typeof value === "string") {
        try {
          allowedBase = JSON.parse(value);
        } catch {
          allowedBase = [value];
        }
      } else if (Array.isArray(value)) {
        allowedBase = value;
      } else {
        allowedBase = [".munshify.com"];
      }
      const url = new URL(config.baseURL);
      const baseURL = url?.origin;
      let UrlAllowed = false;
      const isPublicUrl =
        (config.url ?? "").startsWith("/public/") ||
        (config.url ?? "").startsWith("public/");
      for (const urls of allowedBase) {
        if (baseURL.includes(urls)) {
          UrlAllowed = true;
        }
      }
      if (UrlAllowed) {
        config.headers.resolveWithFullResponse = true;
      }
      if (clientToken && UrlAllowed && !isPublicUrl) {
        config.headers.Authorization = `Bearer ${clientToken}`;
      }
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );
  return axiosInstance;
};

export const addExpiredAuthorizationTokenResponseInterceptor = (
  axiosInstance: AxiosInstance,
  apiClient: IApiClient
): AxiosInstance => {
  axiosInstance.interceptors.response.use(
    (response: AxiosResponse) => {
      return Promise.resolve(response);
    },
    async (error: any) => {
      const originalRequest = error.config;

      const authHelper = apiClient.getAuthHelper();
      if (
        isAuthorizationTokenExpiredError(error) &&
        !originalRequest._retry &&
        authHelper
      ) {
        if (!originalRequest.headers) {
          originalRequest.headers = {};
        }
        // await authHelper?.refreshTokens();
        const accessToken = await authHelper.getAccessToken();
        originalRequest.headers.Authorization = `Token ${accessToken}`;
        originalRequest._retry = true;
        return await apiClient.request(originalRequest);
      }
      errorHandler(error);
      return Promise.reject(error);
    }
  );
  return axiosInstance;
};

const isAuthorizationTokenExpiredError = (error: any): boolean => {
  if (
    HTTP_STATUS_CODES?.Unauthorized === error?.response?.data?.statusCode &&
    AUTH_TOKEN_EXPIRED_MESSAGE === error?.response?.data?.statusMessage
  ) {
    // store.dispatch(logoutAction()); // to be removed
    const redirectUri = getRedirectUri();
    if (redirectUri === window.location.origin) {
      const store = getStore();
      store.dispatch(logoutAction());
    } else {
      UserService.doLogin();
    }
    return true;
  }
  return false;
};

const errorHandler = (error: any) => {
  if (error.response && error.response.data && error.response.data.data) {
    const errorData = error.response.data.data;
    switch (errorData.code) {
      case ERR_UNSUPPORTED_VERSION:
        // StoreProviderService.getStore().dispatch(updateAppUpgradeFlag(true));
        break;
      case UNDER_MAINTENANCE:
        // const maintenance: IMaintenanceInfo = {
        //   showServerMaintenanceInfo: true,
        //   message: errorData.message,
        //   description: errorData.description,
        // };
        // StoreProviderService.getStore().dispatch(updateServerMaintenanceFlag(maintenance));
        break;
      default: // do nothing
    }
  }
};
